module.exports = __webpack_public_path__ + "img/cover254.3024fc5a.png";